import moment from "moment";

/**
 * Ligne de supplément / accessoire d'un bon de commande.
 */
export interface SupplementForm {
  szLibelle: string;
  fMontant: number;
  fTauxTva: number;
  szTypeTVA: string;
}

/**
 * Formulaire vierge d'un bon de commande (BDC).
 *
 * Volontairement isolé dans un module feuille (dépendance unique : moment) :
 * il est consommé au chargement du module par `bdcPdfExtractor`, alors que
 * `@/utils/index` tire tout le store (router -> store -> modules), ce qui
 * créait un cycle d'imports et rendait `getDefaultForm` indéfini selon le
 * point d'entrée. Ne pas y ajouter d'import applicatif.
 */
export function getDefaultForm() {
  const nowDisplay = moment().format("DD/MM/YYYY");
  return {
    userIpn: "",
    szIdentifiantRR: "",
    szRattachement: "",
    szNomVendeur: "",
    szPrenomVendeur: "",
    szTypeClient: "",
    szCiviliteClient: "M.",
    szNomClient: "",
    szPrenomClient: "",
    szAdresseClient: "",
    szCodePostalClient: "",
    szVilleClient: "",
    szTelClientPortable: "",
    szTelClientDomicile: "",
    szEmailClient: "",
    szRaisonSocialClient: "",
    szNumeroSiretClient: "",
    szMarque: "",
    szGamme: "VP",
    szGenreVehicule: "",
    szModele: "",
    szVersion: "",
    szCouleur: "",
    iKmCompteur: 0,
    szOrigineVO: "",
    fMontantVente: 1,
    fTarifVehiculeTTC: 0,
    fTarifVehiculeHT: 0,
    szNumImmat: "",
    szDatePremiereImmat: "",
    szDateImmat: "",
    szDateLivraison: "",
    szTypeGarantie: "",
    fMontantRemise: 0,
    fTauxTVA: 0.2,
    szTypeTVA: "TC",
    szTypeMINE: "",
    szNumSerie: "",
    szCarosserie: "",
    iPuissance: 0,
    szEnergie: "",
    iPlacesAssises: "" as string,
    iNivCO2: 0,
    fValeurRepriseVO: 0,
    szDateVente: nowDisplay,
    szRepVONom_CG: "",
    szRepVO_Marque: "",
    szRepVO_Modele: "",
    szRepVO_Version: "",
    szRepVO_Km: 0,
    szRepVO_ImmaDate1: "",
    szRepVO_ImmaDate: "",
    szRepVO_Chassis: "",
    szRepVO_Energie: "",
    szRepVO_PrimeConv: 0,
    szRepVO_numImmat: "",
    supplement: [] as SupplementForm[],
    accessoire: [] as unknown[],
    szCommentaire: "",
  };
}
